export const STORAGE_PREFIX = 'gtb-next';
